import {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import AurPizzaTrackerProgress, {
  DataSetReportStatusItem,
} from '../../../common/aur-pizza-traker-progress/AurPizzaTrackerProgress';
import {AurSelect} from '../../../common/aur-select/AurSelect';
import AurButton from '../../../common/aur-button/AurButton';

const proressData: DataSetReportStatusItem[] = [
  {
    status: 'Queued',
    tooltipInfo: 'tbd',
    stepProcessingStatus: 'NotStarted',
    startDate: '2024/10/04 2:00 UTC',
    completeDate: '2024/10/04 2:31 UTC',
    statusLabel: 'Queued',
    errorLabel: 'Failed to queue',
  },
  {
    status: 'Processing',
    tooltipInfo: 'tbd',
    stepProcessingStatus: 'NotStarted',
    startDate: '2024/10/04 2:32 UTC',
    completeDate: '2024/10/04 3:12 UTC',
    statusLabel: 'Processing',
    errorLabel: 'Failed to process',
  },
  {
    status: 'Filtering',
    tooltipInfo: 'tbd',
    stepProcessingStatus: 'NotStarted',
    startDate: '2024/10/04 3:13 UTC',
    completeDate: '2024/10/04 3:59 UTC',
    statusLabel: 'Filtering & Deduping',
    errorLabel: 'Failed to filter & dedupe',
  },
  {
    status: 'Exporting',
    tooltipInfo: 'tbd',
    stepProcessingStatus: 'NotStarted',
    startDate: '2024/10/04 3:59 UTC',
    completeDate: '2024/10/04 4:46 UTC',
    statusLabel: 'Exporting',
    errorLabel: 'Failed to export',
  },
];

const PizzaTrackerProgress: React.FC = () => {
  const [currentState, setCurrentState] = useState<string | null>(null);
  const [progressStepData, setProgressStepData] =
    useState<DataSetReportStatusItem[]>(proressData);

  useEffect(() => {
    const updatedStateItemIndex = proressData.findIndex(
      (item) => item.status === currentState
    );
    const updateState = [...proressData].map((item, index) => {
      const updateItem = {...item};
      if (index < updatedStateItemIndex) {
        updateItem.stepProcessingStatus = 'Completed';
      } else if (index === updatedStateItemIndex) {
        updateItem.stepProcessingStatus = 'InProgress';
      }
      return updateItem;
    });
    setProgressStepData(updateState);
  }, [currentState]);
  const handleStartProgress = () => {
    setCurrentState('Queued');
  };

  const handleEndProgress = () => {
    setCurrentState('Exporting');
    setProgressStepData((state) => {
      const updateState = [...state];
      updateState.forEach((item) => {
        item.stepProcessingStatus = 'Completed';
      });
      return updateState;
    });
  };

  return (
    <div style={{marginBottom: '64px'}}>
      <h1>Animated Pizza Tracker progress bar demo</h1>
      <Link to="/demo">Return</Link>
      <br />
      <div>
        <AurPizzaTrackerProgress progressSteps={progressStepData} />
      </div>
      <div style={{marginTop: '32px', display: 'flex', flexDirection: 'row'}}>
        <div style={{marginRight: '24px'}}>
          <AurButton
            type="continue"
            title="Start Progress"
            label="Start Progress"
            onClick={handleStartProgress}
          />
        </div>
        <div style={{marginRight: '24px'}}>
          <AurSelect
            style={{width: '200px'}}
            label="Update Progress State"
            optionList={progressStepData.map((item) => item.status)}
            field={{
              onChange: () => {
                console.log('On change state');
              },
              value: currentState ?? undefined,
            }}
            fieldState={{}}
            onSelect={(event) => {
              setCurrentState(event.target.value);
            }}
          />
        </div>
        <div style={{marginRight: '24px'}}>
          <AurButton
            type="continue"
            title="End Progress"
            label="End Progress"
            onClick={handleEndProgress}
          />
        </div>
      </div>
    </div>
  );
};

export default PizzaTrackerProgress;
